module.exports = __webpack_public_path__ + "img/cb-lr-yr1.1df2c047.gif";